import { render, staticRenderFns } from "./CriterioSelectHighlightedOffers.vue?vue&type=template&id=ca4c090a"
import script from "./CriterioSelectHighlightedOffers.vue?vue&type=script&lang=js"
export * from "./CriterioSelectHighlightedOffers.vue?vue&type=script&lang=js"
import style0 from "./CriterioSelectHighlightedOffers.vue?vue&type=style&index=0&id=ca4c090a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports